export default __webpack_public_path__ + "static/media/green-4.0d770c68.svg";